/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";

export default graphql`
    query NavigationBarQuery {
        music_viewer {
            pieces_count
        }    
    }
`;